import { Service } from '../types/service'
import { ServiceModel } from '../../models/service'
import { transformProducts } from './product';

export function transformService(service: Service): ServiceModel {
    return {
        ...service,
        products: transformProducts(service.products)
    };
}

export function transformServices(services: Service[]): ServiceModel[] {
    return services.map(transformService);
}
